export enum EFlagFSE {
	/** (Demande de remboursement électronique) */
	DRE = "DRE",
	/** (Feuille de soin électronique) */
	FSE = "FSE",
	/** (FSE avec une prise en charge AMC) */
	ENR = "ENR",
	/** (FSE + DRE) */
	FDE = "FDE",
	/** (Feuille de soins en gestion unique) */
	FSU = "FSU"
}
